//import type { Workbook } from 'types';

export enum AppActionType {
  CHANGE_APP_LOCALE = 'APP.CHANGE_APP_LOCALE',
  ZOOM_PDF = 'APP.ZOOM_PDF',
  SET_SCALE_PDF = 'APP.SET_SCALE_PDF',
  SET_RESOURCE_FILTERS = 'RESOURCE.SET_RESOURCE_FILTERS',
  SELECT_RESOURCE = 'RESOURCE.SELECT_RESOURCE',
  TOGGLE_RESOURCE_PLAYER_VISIBILITY = 'RESOURCE.TOGGLE_RESOURCE_PLAYER_VISIBILITY',
  SELECT_CHARACTER = 'CHARACTER.SELECT_CHARACTER',
  UPDATE_COUNTER = 'UPDATE_COUNTER',
  FETCH_CHARACTERS = 'FETCH_CHARACTERS',
  SET_APP_ID = 'SET_APP_ID',
  APP_TOGGLE_APP_LOADING_SCREEN_VISIBILITY = 'APP.TOGGLE_APP_LOADING_SCREEN_VISIBILITY',
  APP_TOGGLE_TAG = 'APP.TOGGLE_TAG',
  APP_CLEAR_RESOURCE_FILTERS = 'APP.CLEAR_RESOURCE_FILTERS',
  CURRENT_WORKBOOK = 'APP.CURRENT_WORKBOOK',
  SELECT_CLASSROOM = 'SELECT_CLASSROOM',
  CLEAR_SELECTED_CLASSROOM = 'CLEAR_SELECTED_CLASSROOM'
}

export type AppState = {
  app: null;
  currentWorkbook: any | null;
  previousWorkbook: any | null;
  locale: string; // TODO: Locale
  pdfScaleValue: number;
  character: {
    selectedCharacter: {
      characterType: string;
      characterCase: string;
      character: string;
      data: { url: string };
    };
  };
  resource: {
    showResourcePlayer: boolean;
    selectedResource: any;
    selectedFilters: any;
  };
  showLoadingScreen: boolean;
  counter: number | any;
  selectedClassroomId: number | '';
};

export type AppAction =
  | { type: AppActionType.ZOOM_PDF; data: number }
  | { type: AppActionType.CHANGE_APP_LOCALE; data: string }
  | { type: AppActionType.SET_SCALE_PDF; data: number }
  | {
      type: AppActionType.SET_RESOURCE_FILTERS;
      data: { resourceSection: any; searchText: any; selectedTags: any };
    }
  | { type: AppActionType.SELECT_RESOURCE; data: any }
  | { type: AppActionType.TOGGLE_RESOURCE_PLAYER_VISIBILITY }
  | { type: AppActionType.SELECT_CHARACTER; data: any }
  | { type: AppActionType.UPDATE_COUNTER }
  | { type: AppActionType.APP_TOGGLE_APP_LOADING_SCREEN_VISIBILITY }
  | { type: AppActionType.SELECT_CLASSROOM; data: number }
  | { type: AppActionType.CLEAR_SELECTED_CLASSROOM };
